import { useCallback } from 'react';
import { deleteSprint } from './deleteSprint';
import { restoreSprint } from './restoreSprint';
import { permanentlyDeleteSprint, emptyTrash } from './permanentDelete';

/**
 * useSprintTrash Hook
 *
 * Handles all trash-related operations:
 * - Soft-delete (move to trash with TTL)
 * - Restore from trash
 * - Permanent delete
 * - Empty trash
 */
export function useSprintTrash({
  sprints,
  setSprints,
  selectedSprintId,
  setSelectedSprintId,
  selectedTemplateId,
  setSelectedTemplateId,
  setCurrentView,
  VIEWS,
}) {
  const handleDeleteSprint = useCallback(
    (sprintId, options) => deleteSprint({
      sprintId,
      options,
      sprints,
      setSprints,
      selectedSprintId,
      selectedTemplateId,
      setSelectedSprintId,
      setSelectedTemplateId,
      setCurrentView,
      VIEWS,
    }),
    [sprints, selectedSprintId, selectedTemplateId, setSprints, setSelectedSprintId, setSelectedTemplateId, setCurrentView, VIEWS]
  );

  const handleRestoreSprint = useCallback(
    (sprintId) => restoreSprint({ sprintId, sprints, setSprints }),
    [sprints, setSprints]
  );

  const handlePermanentlyDeleteSprint = useCallback(
    (sprintId) => permanentlyDeleteSprint({
      sprintId,
      sprints,
      setSprints,
      selectedSprintId,
      selectedTemplateId,
      setSelectedSprintId,
      setSelectedTemplateId,
      setCurrentView,
      VIEWS,
    }),
    [sprints, selectedSprintId, selectedTemplateId, setSprints, setSelectedSprintId, setSelectedTemplateId, setCurrentView, VIEWS]
  );

  const handleEmptyTrash = useCallback(
    () => emptyTrash({
      sprints,
      setSprints,
      selectedSprintId,
      selectedTemplateId,
      setSelectedSprintId,
      setSelectedTemplateId,
      setCurrentView,
      VIEWS,
    }),
    [sprints, selectedSprintId, selectedTemplateId, setSprints, setSelectedSprintId, setSelectedTemplateId, setCurrentView, VIEWS]
  );

  return {
    handleDeleteSprint,
    handleRestoreSprint,
    handlePermanentlyDeleteSprint,
    handleEmptyTrash,
  };
}

export default useSprintTrash;
